/* eslint-disable no-nested-ternary */
import {
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    Divider,
    Grid
} from '@mui/material';
import { ActionButton, CancelButtonGrey } from '@tassat/button';
import * as React from 'react';

import muiStyles from './styles';
import { ConfirmationModalProps } from './types';

export default function ConfirmationModal(props: ConfirmationModalProps) {
    const {
        open,
        title,
        body,
        buttonStyling,
        noBodyPadding,
        confirmDisabled,
        actionInProgress,
        displayCancelButton = true,
        confirmButtonText = 'Confirm',
        cancelButtonText = 'Cancel',
        onConfirm,
        onClose,
        goBack
    } = props;

    const classes = muiStyles(props);

    return (
        <Dialog
            classes={{ paperWidthXl: classes.paperWidthXl }}
            disableEscapeKeyDown
            maxWidth='xl'
            onClose={(event, reason) => {
                if (reason === 'backdropClick') return;
                onClose();
            }}
            open={open}
            transitionDuration={{
                enter: 0,
                exit: 0
            }}
        >
            <Grid
                className={classes.root}
                container
                direction='column'
                spacing={0}
                wrap='nowrap'
            >
                <Grid
                    className={classes.titleContainer}
                    container
                    item
                    spacing={0}
                    xs={12}
                >
                    <Grid
                        item
                        xs={11}
                    >
                        <DialogContentText className={classes.title}>
                            {title || 'Please Confirm'}
                        </DialogContentText>
                    </Grid>
                    <Grid
                        className={classes.cancelButton}
                        item
                        xs={1}
                    >
                        <CancelButtonGrey onClick={onClose} />
                    </Grid>
                </Grid>
                <Divider variant='middle' />
                <Grid
                    item
                    xs={12}
                >
                    <DialogContent>
                        {
                            typeof body === 'string' ?
                                <DialogContentText className={classes.bodyText}>{body}</DialogContentText>
                                : <div className={!noBodyPadding ? classes.bodyElementContainer : ''}>{body}</div>
                        }
                    </DialogContent>
                </Grid>
                <Grid
                    container
                    item
                    justifyContent={goBack ? 'center' : 'flex-end'}
                    spacing={2}
                    xs={12}
                >
                    <DialogActions>
                        {displayCancelButton && <ActionButton
                            className={buttonStyling === 'boldRound' ? classes.scCancel : ''}
                            disabled={actionInProgress}
                            handleClick={goBack || onClose}
                            text={cancelButtonText}
                            type='muted'
                        />}
                        <ActionButton
                            actionInProgress={actionInProgress}
                            className={buttonStyling === 'boldRound' ? classes.scSubmit : ''}
                            disabled={confirmDisabled || actionInProgress}
                            handleClick={onConfirm}
                            text={confirmButtonText}
                            type='primary'
                        />
                    </DialogActions>
                </Grid>
            </Grid>
        </Dialog>
    );
}